export const OFFER_VIEW = 'offer_view';
export const OFFER_CARD_VIEW = 'offer_card_view';
export const OFFER_CREATE = 'offer_create';
export const OFFER_CARD_CREATE = 'offer_card_create';

export const OFFER_EDIT = 'offer_edit';
export const OFFER_CARD_EDIT = 'offer_card_edit';
export const OFFER_TYPE = 'offer_type';
export const OFFERS = 'Offers';
export const OFFER_CARDS = 'Offer Cards';
export const STATUS = [
  { id: 'Live', name: 'Live', selected: false },
  { id: 'Scheduled', name: 'Scheduled', selected: false },
  { id: 'Completed', name: 'Completed', selected: false },
  { id: 'Inactive', name: 'Inactive', selected: false },
];
export const OFFERS_TYPE = [
  { id: 'F&B', name: 'F&B', selected: false },
  { id: 'IRD', name: 'IRD', selected: false },
  { id: 'Stay', name: 'Stay', selected: false },
  { id: 'Spa', name: 'Spa', selected: false },
  { id: 'Sidecar', name: 'Sidecar', selected: false },
  {
    id: 'Meetings & Events',
    name: 'Meetings & Events',
    selected: false,
  },
  { id: 'Weddings', name: 'Weddings', selected: false },
  { id: 'Experience', name: 'Experience', selected: false },
  { id: 'Festive', name: 'Festive', selected: false },
  { id: 'Dine In', name: 'Dine In', selected: false },
  { id: 'Landing Offers', name: 'Landing Offers', selected: false },
  { id: 'Hydrotour', name: 'Hydrotour', selected: false },
  { id: 'News Papers', name: 'News Papers', selected: false },
  { id: 'Sustainability', name: 'Sustainability', selected: false },
  { id: 'Dine', name: 'Dine', selected: false },
  { id: 'Wellness', name: 'Wellness', selected: false },
  { id: 'Events', name: 'Events', selected: false },
  { id: 'Others', name: 'Others', selected: false },
];

export const AR_OFFERS_TYPE = [
  { id: 'F&B', name: 'المأكولات والمشروبات', selected: false },
  { id: 'IRD', name: 'خدمة الغرف', selected: false },
  { id: 'Stay', name: 'الإقامة', selected: false },
  { id: 'Spa', name: 'السبا', selected: false },
  { id: 'Sidecar', name: 'سايد كار', selected: false },
  { id: 'Meetings & Events', name: 'الاجتماعات والفعاليات', selected: false },
  { id: 'Weddings', name: 'حفلات الزواج', selected: false },
  { id: 'Experience', name: 'تجارب', selected: false },
  { id: 'Festive', name: 'موسمية', selected: false },
  { id: 'Dine In', name: 'تناول الطعام في المطعم', selected: false },
  { id: 'Landing Offers', name: 'عروض الصفحة الرئيسية', selected: false },
  { id: 'Hydrotour', name: 'جولة مائية', selected: false },
  { id: 'News Papers', name: 'الجريدة', selected: false },
  { id: 'Sustainability', name: 'الاستدامة', selected: false },
  { id: 'Dine', name: 'تعشّى', selected: false },
  { id: 'Wellness', name: 'العافية', selected: false },
  { id: 'Events', name: 'الفعاليات', selected: false },
  { id: 'Others', name: 'معلومات أخرى', selected: false },
];

export const OFFER_CARDS_TYPE = [
  { id: 'Scratch Card', name: 'Scratch Card', selected: false },
  { id: 'Pop-up Card', name: 'Pop-up Card', selected: false },
];

export const OFFER_CARDS_DROPDOWN_TYPE = [
  { id: 'SCRATCH_CARD', name: 'Scratch Card' },
  { id: 'POPUP_CARD', name: 'Pop-up Card' },
];

export const OFFER_CARDS_DROPDOWN_RECURS = [
  { id: 'DAY', name: 'Day' },
  { id: 'WEEK', name: 'Week' },
  { id: 'MONTH', name: 'Month' },
];

export const OFFER_RECIPIENT_DROPDOWN = [
  { id: 'all', name: 'All Guests' },
  { id: 'inHouse', name: 'In-house Guests Only' },
];

export const OFFER_CARDS_FILTER = [
  {
    title: 'All',
    field: 'all',
    subMenu: [],
  },
  {
    title: 'Type',
    field: 'type',
    subMenu: OFFER_CARDS_TYPE,
  },
  {
    title: 'Status',
    field: 'status',
    subMenu: STATUS,
  },
];
export const OFFER_FILTER = [
  {
    title: 'All',
    field: 'all',
    subMenu: [],
  },
  {
    title: 'Type',
    field: 'type',
    subMenu: OFFERS_TYPE,
  },
  {
    title: 'Status',
    field: 'status',
    subMenu: STATUS,
  },
];
export const REDIRECT_OPTIONS = [
  'External URL',
  'IRD',
  'Restaurant',
  'Spa',
  'Book Room',
  'Experiences',
  'Meetings & Events',
];

export const OFFER_REDIRECT_OPTIONS = ['External URL', 'In-App Page', 'Flow', 'Module'];

export const OFFER_CARD_MODULES = [
  { id: 'RESTAURANT', name: 'Restaurant' },
  { id: 'SPA', name: 'Spa' },
  { id: 'ACCOMMODATION', name: 'Accommodation' },
  { id: 'CHECK_IN', name: 'Check In' },
  { id: 'DIGITAL_KEY', name: 'Digital Key' },
  { id: 'FEEDBACK', name: 'Feedback' },
  { id: 'GRMS', name: 'GRMS' },
  { id: 'HOTEL_COMPENDIUM', name: 'Hotel Compendium' },
  { id: 'LOYALTY', name: 'Loyalty' },
  { id: 'IRD', name: 'IRD' },
  { id: 'SERVICE_REQUEST', name: 'Service Request' },
  { id: 'HOTEL_INFO', name: 'Hotel Info' },
  { id: 'OFFERS', name: 'Offers' },
];

export const OFFER_MODULES = ['Restaurant', 'Spa', 'IRD'];

export const modulesWithoutSubModule = [
  { id: 'CHECK_IN', name: 'Check In' },
  { id: 'GRMS', name: 'GRMS' },
  { id: 'LOYALTY', name: 'Loyalty' },
  { id: 'DIGITAL_KEY', name: 'Digital Key' },
  { id: 'HOTEL_INFO', name: 'Hotel Info' },
  { id: 'FEEDBACK', name: 'Feedback' },
];

export const CTA_TYPES = [
  { name: 'Ok', id: 'OK' },
  { name: 'Redeem', id: 'REDEEM' },
  { name: 'Enquire', id: 'ENQUIRE' },
];
export const CTA_CARD_PLACEMENT_MODULE_LIST = [
  { name: 'Restaurant', id: 'RESTAURANT', status: true },
  { name: 'Spa', id: 'SPA', status: true },
  { name: 'Accommodation', id: 'ACCOMMODATION', status: true },
  { name: 'Hotel Compendium', id: 'HOTEL_COMPENDIUM', status: true },
  { name: 'Menu Configs', id: 'MENU_CONFIGS', status: true },
  { name: 'City Guide', id: 'CITY_GUIDE', status: true },
];
export const OFFER_NOTIFICATION_CREATE = 'offer_notification_create';
export const OFFER_NOTIFICATION_DEVICE = ['Mobile', 'Web', 'Tablet', 'TV'];
export const OFFER_TABS = ['Details', 'CTA', 'Schedule', 'Contact', 'Media', 'Push Notifications'];
export const OFFER_CARD_TABS = ['Details', 'CTA', 'Schedule', 'Media'];
export const VALID_DATE_ERROR_MESSAGE = 'Valid Till date should be greater than valid From date';
export const OFFER_VALID_DATE_ERROR_MESSAGE = 'End date should be greater than start date';
export const VALID_TIME_ERROR_MESSAGE = 'Valid Till time should be greater than valid From time';
export const OFFER_INVALID_TIME_ERROR_MESSAGE = 'Invalid Time';
export const VALID_CURRENT_TIME_ERROR_MESSAGE =
  'Selected time must be greater than the current time.';
export const VALID_SCHEDULE_TIME_ERROR_MESSAGE =
  'Popup time must be between From Time and To Time.';

export const DAYS = [
  { id: 1, ischecked: false, name: 'Monday', isDisable: false },
  { id: 2, ischecked: false, name: 'Tuesday', isDisable: false },
  { id: 3, ischecked: false, name: 'Wednesday', isDisable: false },
  { id: 4, ischecked: false, name: 'Thursday', isDisable: false },
  { id: 5, ischecked: false, name: 'Friday', isDisable: false },
  { id: 6, ischecked: false, name: 'Saturday', isDisable: false },
  { id: 0, ischecked: false, name: 'Sunday', isDisable: false },
];
